export const ADD_USER_DATA = "ADD_USER_DATA";
export const SET_ALERT_DATA = "SET_ALERT_DATA";
